import { Navigate, useRoutes } from "react-router-dom";
// config
import { PATH_AFTER_LOGIN } from "src/config-global";
//
import { mainRoutes } from "./main";
import { authRoutes } from "./auth";
import { authDemoRoutes } from "./auth-demo";
import { dashboardRoutes } from "./dashboard";
import { managementRoutes } from "./management";
import { componentsRoutes } from "./components";

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    // ----------------------------------------------------------------------

    // SET INDEX PAGE WITH HOME PAGE
    {
      path: "/",
      element: (
        <Navigate
          to={PATH_AFTER_LOGIN}
          replace
        />
      ),
    },

    // Auth routes
    ...authRoutes,
    ...authDemoRoutes,

    // Dashboard routes
    ...dashboardRoutes,

    // Management routes
    ...managementRoutes,

    // Main routes
    ...mainRoutes,

    // Components routes
    ...componentsRoutes,

    // No match 404
    {
      path: "*",
      element: (
        <Navigate
          to="/404"
          replace
        />
      ),
    },
  ]);
}
